import { logButtonClick } from '../modules/logger.js'

export function useLogger() {
  const logClick = async (buttonName, windowName) => {
    await logButtonClick(buttonName, windowName)
  }

  return { logClick }
}